import state from './moduleTemplateState'
import actions from './moduleTemplateActions'
import getters from './moduleTemplateGetters'
import mutations from './moduleTemplateMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

